import React from 'react';
import { LoadingSkeleton } from '../LoadingSkeleton/LoadingSkeleton';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export type ProductImageFallbackProps = {
  className?: string;
  shouldHideBorder?: boolean;
  backgroundColor?: string;
};

export const ProductImageFallback = ({
  className,
  shouldHideBorder = false,
  backgroundColor = palette.secondary.main,
}: ProductImageFallbackProps) => {
  return (
    <LoadingSkeleton.Image
      className={className}
      shouldShimmer={false}
      backgroundColor={backgroundColor}
      shimmerColor={palette.border.main}
      border={shouldHideBorder ? 'none' : undefined}
    />
  );
};
